import useTasksService from '../../api/useTasksService';
import { ApprovalHistoryItem, MiddlewareTaskApproval } from '../../types/tasks';
const {
  sendForApproval,
  sendTaskApprovalStatus,
  requestTaskChanges,
  withdrawApproval,
  resendRequest,
  resolveRequest,
  fetchApproval,
} = useTasksService();

export const taskApprovalSlice: MiddlewareTaskApproval = (set, get) => ({
  onSendForApproval: async (
    taskId: string,
    approvers: string[],
    approversAdded: string[],
    approversRemoved: string[],
    minApprovers: number
  ) => {
    const task = get()?.tasks[taskId];
    if (!task?.id) return false;
    set((state) => {
      const { tasks } = state;
      const task = tasks[taskId];
      // if (task && task?.approval && approvers.length > 0) {
      //   task.approval.minApprovalsRequired = minApprovers;
      // }
    });

    const approval = await sendForApproval({
      taskId,
      approversAdded,
      approversRemoved,
      minApprovers,
    });
    const success = !!approval;
    if (success) {
      get()?.setTask(task.id, { ...task, approval: approval });
    } else {
      get()?.setTask(task.id, { ...task });
    }
    return success;
  },

  showHistory: true,
  setShowHistory: (showHistory) => {
    set((state) => {
      state.showHistory = showHistory;
    });
  },
  onUpdateTaskHistory: async (taskId: string, historyItem: ApprovalHistoryItem) => {
    set((state) => {
      const { tasks } = state;
      const task = tasks[taskId];
      if (task && task?.approval) {
        const data = task.approval.approvalHistory || [];
        data.push(historyItem);
        task.approval.approvalHistory = data;
      }
    });
  },

  onSetTaskApprovalStatus: async (
    taskId: string,
    status: string,
    memberId: string,
    comments?: string
  ) => {
    const task = get()?.tasks[taskId];
    if (!task?.id) return false;

    set((state) => {
      const { tasks } = state;
      const task = tasks[taskId];
      if (task && task?.approval?.approvers && task?.approval?.approvers.length > 0) {
        const approvers_temp = task.approval.approvers?.filter((item) => item.member !== memberId);
        task.approval.approvers = approvers_temp;
      }
    });

    const approval = await sendTaskApprovalStatus({
      taskId,
      comments,
      status,
    });
    const success = !!approval;
    if (success) {
      get()?.setTask(task.id, { ...task, approval: approval });
    } else {
      get()?.setTask(task.id, { ...task });
    }
    return success;
  },

  onWithdrawTaskApproval: async (taskId: string) => {
    const task = get()?.tasks[taskId];
    if (!task?.id) return false;

    set((state) => {
      const { tasks } = state;
      const task = tasks[taskId];
      if (task && task?.approval?.isTaskWithdrawn) {
        task.approval.isTaskWithdrawn = true;
      }
    });

    const approval = await withdrawApproval({
      taskId,
    });
    const success = !!approval;
    if (success) {
      get()?.setTask(task.id, { ...task, approval: approval });
    } else {
      get()?.setTask(task.id, { ...task });
    }
    return success;
  },

  onRequestChanges: async (taskId: string, comments?: string) => {
    const approval = await requestTaskChanges({
      taskId,
      comments,
    });
    const success = !!approval;
    if (success) {
      set((state) => {
        const { tasks } = state;
        const task = tasks[taskId];
        if (task) {
          task.approval = approval;
        }
      });
    }
    return success;
  },

  onResendRequest: async (taskId: string, member: string) => {
    const approval = await resendRequest({
      taskId,
      member,
    });
    const success = !!approval;
    if (success) {
      set((state) => {
        const { tasks } = state;
        const task = tasks[taskId];
        if (task) {
          task.approval = approval;
        }
      });
    }
    return success;
  },

  onResolveRequest: async (taskId: string, comments: string, id: string) => {
    const approval = await resolveRequest({
      taskId,
      comments,
      id,
    });
    const success = !!approval;
    if (success) {
      set((state) => {
        const { tasks } = state;
        const task = tasks[taskId];
        if (task) {
          task.approval = approval;
        }
      });
    }
    return success;
  },
  onFetchApprovalInfo: async (taskId: string) => {
    const approval = await fetchApproval({
      taskId,
    });
    const success = !!approval;
    if (success) {
      set((state) => {
        const { tasks } = state;
        const task = tasks[taskId];
        if (task) {
          task.approval = approval;
        }
      });
    }
    return success;
  },
});
